import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { ChevronLeft, ChevronRight, Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './assets/css/App.css'
import './assets/css/bootstrap.min.css'
import './assets/css/agency.min.css'
import mainLogo from './assets/img/mainLogo.png'
import img1 from './assets/img/images1.jpeg'
import img2 from './assets/img/images2.jpeg'
import img3 from './assets/img/images3.jpeg'
import img4 from './assets/img/images4.jpeg'
import img5 from './assets/img/1.jpg'
import img6 from './assets/img/2.jpg'
import img7 from './assets/img/3.jpg'
import img8 from './assets/img/4.jpg'
import CardComponent from './components/projects';
import vit1 from './assets/img/vit1.png'
import vit2 from './assets/img/vit2.png'
import ssn from './assets/img/ssn.png'
import idsschool from './assets/img/idsschool.png'
import cmc from './assets/img/cmc_logo.png'
import narayani from './assets/img/narayani_logo.png'
import water from './assets/img/water_management.png'
import energy from './assets/img/energy_management.png'
// import doorlock from 'src/screens/Landing/assets/img/door_lock.mp4'
import farmland from './assets/img/forest.jpg'
import whatsappnumber from './assets/img/whatsappnumber.jpg'
import TamilNaduForestDepartment from './assets/img/TamilNaduForestDepartment.png'
import KarnatakaForestDepartment from './assets/img/KarnatakaForestDepartment.png'
import crescentLogo from './assets/img/crescent-logo.png'
import './landing-page.css';

const navigation = [
  { id: 'home', href: '#page-top', label: 'Home' },
  { id: 'vision&mission', href: '#vision&mission', label: 'Vision & Mission' },
  { id: 'products', href: '#products', label: 'Products' },
  { id: 'testimonials', href: '#testimonials', label: 'Testimonials' },
  { id: 'Clients', href: '#Clients', label: 'Clients' },
  { id: 'about', href: '#about', label: 'About' },
  { id: 'services', href: '#services', label: 'Services' },
  { id: 'contact', href: '#contact', label: 'Contact' },
];

const heroSlides = [
  { image: img4, alt: 'Elephants in green farmland', subtitle: 'AI & ML Based Farm Guard' },
  { image: img1, alt: 'Water conservation', subtitle: 'Water Level Controller & Indicator' },
  { image: img2, alt: 'Protecting the environment', subtitle: 'With Your Love We Can Save the World' },
  { image: img3, alt: 'Energy conservation', subtitle: 'Power Saver and Energy Sparing' },
];

const missionItems = [
  { title: 'Save Crops', description: 'Save Crops from animals enhances Crop Yields', image: 'https://img.icons8.com/?size=100&id=Lkm9R6V4xCAv&format=png&color=000000' },
  { title: 'Save Human Life', description: "One life protected, is a forest's peace preserved.", image: 'https://img.icons8.com/?size=100&id=3Ib0Q5LVV6Zt&format=png&color=000000' },
  { title: 'Protect Wildlife', description: "One creature protected, is nature's future secured.", image: 'https://img.icons8.com/?size=100&id=101744&format=png&color=000000' },
  { title: 'Save Water', description: 'Automatic & Manual type Energy Saving, Resistant, Monitoring.', image: 'https://img.icons8.com/external-others-cattaleeya-thongsriphong/64/000000/external-Water-ecology-outline-others-cattaleeya-thongsriphong.png' },
  { title: 'IOT Projects', description: 'The internet of things has the potential to change the world just as the internet did may be even more.', image: 'https://img.icons8.com/external-itim2101-lineal-itim2101/64/000000/external-smart-home-internet-of-things-itim2101-lineal-itim2101.png' },
  { title: 'Monitor & Control', description: 'The best way to save things is to monitor and control and that is what we are doing.', image: 'https://img.icons8.com/external-itim2101-lineal-itim2101/64/000000/external-laptop-devices-service-itim2101-lineal-itim2101-2.png' },
  { title: 'Easy Installation', description: 'With existing setup, we can install our product without disturbing any circuits.', image: 'https://img.icons8.com/external-out-line-pongsakorn-tan/64/000000/external-installation-help-and-support-out-line-pongsakorn-tan.png' },
  { title: 'Best Service', description: 'We assure you of our best service at all times.', image: 'https://img.icons8.com/external-flaticons-lineal-flat-icons/64/000000/external-services-inhome-service-flaticons-lineal-flat-icons-2.png' },
];

const clientLogos = [
  { image: TamilNaduForestDepartment, name: 'Tamil Nadu Forest Department' },
  { image: KarnatakaForestDepartment, name: 'Karnataka Forest Department' },
  { image: vit1, name: 'VIT' },
  { image: vit2, name: 'VIT Institution' },
  { image: ssn, name: 'SSN' },
  { image: idsschool, name: 'IDS School' },
  { image: cmc, name: 'CMC' },
  { image: narayani, name: 'Narayani' },
  { image: crescentLogo, name: 'Crescent' },
];

type LandingJQuery = {
  (element: HTMLElement): { carousel(action?: "dispose"): void };
  fn?: { carousel?: unknown };
};

function LandingPage() {
  useEffect(() => {
    const carousel = document.getElementById("demo");
    const jQuery = (window as Window & { jQuery?: LandingJQuery }).jQuery;
    if (!carousel || !jQuery?.fn?.carousel) return;

    const instance = jQuery(carousel);
    instance.carousel();
    return () => instance.carousel("dispose");
  }, []);

  const data1={name:'Farm Guard',Type:'Automatic',Features:'Monitoring land,Protect crops from animal intrusions',Sensor:'Yes',
  Range:'Anywhere',Brand:'BG Enterprises (BGENT)'}
  const data2={name:'Smart Door Lock Detector and Monitor',Type:'Automatic & Manual',Features:'Energy Saving, Resistant, Monitoring',Sensor:'Yes',
  Range:'Anywhere',Brand:'BG Enterprises (BGENT)'}
  const data3={name:'Smart Timer Controller',Type:'Energy Saving, Manual & Automatic',Features:'Energy efficiency & Control from anywhere & Monitor',Sensor:'Yes',
  Range:'Full based on WiFi',Brand:'BG Enterprises (BGENT)'}
  const data4={name:'Smart Motion Detector',Type:'Automatic',Features:'Energy Saving',Sensor:'Yes',
  Range:'Anywhere',Brand:'BG Enterprises (BGENT)'}
  
  const [selected, setSelected] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const sections = ['demo', ...navigation.slice(1).map(item => item.id)]
      .map(id => document.getElementById(id))
      .filter((section): section is HTMLElement => Boolean(section));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setSelected(entry.target.id === 'demo' ? 'home' : entry.target.id);
      });
    }, { rootMargin: '-80px 0px -55% 0px' });
    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, []);

  return (
    <div className="App landing-page" id="page-top">
      <nav className="landing-nav fixed-top" id="mainNav" aria-label="Main navigation">
        <div className="container">
          <a className="landing-brand" href="#page-top" onClick={() => setMenuOpen(false)}>
            <img src={mainLogo} alt="" width="48" height="48" />
            <span>BGENT</span>
          </a>
          <button className="landing-menu-toggle" type="button"
            onClick={() => setMenuOpen(open => !open)}
            aria-controls="navbarResponsive" aria-expanded={menuOpen}
            aria-label={menuOpen ? 'Close navigation' : 'Toggle navigation'}
            title={menuOpen ? 'Close navigation' : 'Open navigation'}>
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <div className={`landing-nav-links ${menuOpen ? 'is-open' : ''}`} id="navbarResponsive">
            <ul>
              {navigation.map(item => (
                <li key={item.id}>
                  <a href={item.href} aria-current={selected === item.id ? 'location' : undefined}
                    onClick={() => { setSelected(item.id); setMenuOpen(false); }}>
                    {item.label}
                  </a>
                </li>
              ))}
              <li><Button id="login" variant="contained" color="success"
                onClick={() => { setMenuOpen(false); navigate('/login'); }}>Login</Button></li>
            </ul>
          </div>
        </div>
      </nav>

      <div id="demo" className="carousel slide landing-hero" data-ride="carousel" aria-label="BG Enterprises">
        <div className="carousel-inner">
          {heroSlides.map((slide, index) => (
            <div key={slide.subtitle} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
              <img className="landing-hero-image" src={slide.image} alt={slide.alt}
                width="1100" height="700" decoding="async" />
              <div className="landing-hero-shade" />
              <div className="container landing-hero-content">
                {index === 0 ? <h1>BG Enterprises</h1> : <h2>BG Enterprises</h2>}
                <p>{slide.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
        <button className="landing-slide-control landing-slide-prev" type="button"
          data-target="#demo" data-slide="prev" aria-label="Previous slide" title="Previous slide">
          <ChevronLeft size={26} />
        </button>
        <button className="landing-slide-control landing-slide-next" type="button"
          data-target="#demo" data-slide="next" aria-label="Next slide" title="Next slide">
          <ChevronRight size={26} />
        </button>
        <div className="carousel-indicators">
          {heroSlides.map((slide, index) => (
            <button key={slide.subtitle} type="button" data-target="#demo" data-slide-to={index}
              className={index === 0 ? 'active' : ''} aria-label={`Show ${slide.subtitle}`}
              title={slide.subtitle} />
          ))}
        </div>
      </div>


  {/* <div style={{position: 'relative', width: '100%', height: 0, padding-top: '56.2500%',
 padding-bottom: 0, box-shadow: '0 2px 8px 0 rgba(63,69,81,0.16)', margin-top: '1.6em', margin-bottom: '0.9em', overflow: 'hidden',
 border-radius: '8px', will-change: 'transform',}}>
  <iframe loading="lazy" style={{position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, border: 'none', padding: 0,margin: 0}}
    src="https:&#x2F,&#x2F,www.canva.com&#x2F,design&#x2F,DAFQ9J9yBm4&#x2F,watch?embed" allowfullscreen="allowfullscreen" allow="fullscreen">
  </iframe>
</div> */}


  <section className="page-section" id="vision&mission">
    <div className="container">
      <h2 className="section-heading">Vision &amp; Mission</h2>
      <h3 className="section-subheading text-muted">We work till zero wastage of water &amp; electricity is achieved in this earth &amp; to save environment.</h3>
      <div className="landing-mission-grid">
        {missionItems.map(item => (
          <div className="landing-mission-item" key={item.title}>
            <div className="landing-mission-icon">
              <img src={item.image} alt="" width="56" height="56" loading="lazy" decoding="async" />
            </div>
            <h4>{item.title}</h4>
            <p className="text-muted">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>

  {/* <section className="page-section" id="products" style={{backgroundColor:'#F5F5F5'}} onMouseEnter={()=>setSelected('products')}>
      <div className="row mx-auto">
        <div className="col-lg-12 text-center">
          <h2 className="section-heading text-uppercase">Our Products</h2>
          <div className="row text-center align-center ">
          <div className="col-md-3">
          <CardComponent data={data1} />
          </div>
          <div className="col-md-3">
          <CardComponent data={data2}/>
          </div>
          <div className="col-md-3">
          <CardComponent data={data3} />
          </div>
          <div className="col-md-3">
          <CardComponent data={data4}/>
          </div>
          </div>
        </div>
      </div>     
  </section> */}
  <section
  className="page-section"
  id="products"
  style={{ backgroundColor: "#F5F5F5" }}
  onMouseEnter={() => setSelected("products")}
>
  <div className="container">
    <div className="text-center">
      <h2 className="section-heading text-uppercase">Our Products</h2>
    </div>

    <div className="row justify-content-center text-center mt-4">
      <div className="col-10 col-sm-6 col-md-3 mb-4 d-flex justify-content-center">
        <CardComponent data={data1} />
      </div>
      <div className="col-10 col-sm-6 col-md-3 mb-4 d-flex justify-content-center">
        <CardComponent data={data2} />
      </div>
      <div className="col-10 col-sm-6 col-md-3 mb-4 d-flex justify-content-center">
        <CardComponent data={data3} />
      </div>
      <div className="col-10 col-sm-6 col-md-3 mb-4 d-flex justify-content-center">
        <CardComponent data={data4} />
      </div>
    </div>
  </div>
</section>

  <section className="page-section" id="testimonials">
    <div className="container landing-evidence">
      <div>
        <h2 className="section-heading">Testimonials</h2>
        <div className="landing-evidence-images">
          <img src={img6} alt="Feedback from Mr. Marudhan at Irular Padhi" width="1080" height="1080" loading="lazy" decoding="async" />
          <img src={img7} alt="Farm Guard customer testimonial" width="1080" height="1080" loading="lazy" decoding="async" />
        </div>
      </div>
      <div>
        <h2 className="section-heading">Real Time Captures</h2>
        <div className="landing-evidence-images">
          <img src={img5} alt="Farm Guard camera capture of a detected leopard" width="1080" height="1080" loading="lazy" decoding="async" />
          <img src={img8} alt="Farm Guard wildlife detection camera capture" width="1080" height="1080" loading="lazy" decoding="async" />
        </div>
      </div>
    </div>
  </section>

  <section className="page-section" id="Clients">
    <div className="container">
      <h2 className="section-heading">Our Valuable Customers</h2>
      <div className="landing-clients">
        {clientLogos.map(client => (
          <div key={client.name} className="landing-client">
            <img src={client.image} alt={client.name} className={client.image === crescentLogo ? 'landing-crescent-logo' : undefined}
              loading="lazy" decoding="async" />
          </div>
        ))}
      </div>
    </div>
  </section>
  
  <section className="page-section" id="about" style={{backgroundColor:'#F5F5F5'}} onMouseEnter={()=>setSelected('about')}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12 text-center">
          <h2 className="section-heading text-uppercase">About Us</h2>
          <h3 className="section-subheading text-muted"></h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <ul className="timeline">
            <li>
              <div className="timeline-image" >
                <img loading="lazy" decoding="async"  style={{marginTop:'15px',width:'125px',height:'125px'}} src="https://img.icons8.com/clouds/100/000000/potted-plant.png" alt=""/>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4>Dec-2018 </h4>
                  <h4 className="subheading">Our Journey Begins</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">
                  BGENT is a pioneering company specializing in the research, development, and manufacturing of innovative electrical and electronic devices. With a strong focus on societal welfare, our products aim to conserve vital resources such as water and electricity. With over three years of experience in the R&D sector, we are committed to delivering cutting-edge solutions that make a meaningful impact.
                  </p>
                </div>
              </div>
            </li>
            <li className="timeline-inverted">
              <div className="timeline-image">
                <img loading="lazy" decoding="async" style={{marginTop:'25px',width:'100px',height:'100px'}} src="https://img.icons8.com/external-wanicon-lineal-color-wanicon/64/000000/external-plant-free-time-wanicon-lineal-color-wanicon.png" alt=""/>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4>Jan-2019</h4>
                  <h4 className="subheading">Our First Breakthrough</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">In January 2019, we achieved a significant milestone with the creation of our first product, the Water Level Controller. This device revolutionizes water management by automatically preventing overflow, thereby minimizing water wastage.
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div className="timeline-image">
                <img loading="lazy" decoding="async" style={{marginTop:'25px',width:'100px',height:'100px'}} className="" src="https://img.icons8.com/external-nawicon-outline-color-nawicon/64/000000/external-door-lock-internet-of-things-nawicon-outline-color-nawicon.png" alt=""/>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4>2019</h4>
                  <h4 className="subheading">A Year of Innovation</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">In 2019, we introduced the Smart Door Lock Detector and Monitor, a groundbreaking device that utilizes IoT and sensors. 
                  Designed for college hostels and hotels, this device intelligently manages electrical instruments, ensuring they are turned off when the door is closed from outside and 
                  turned on when the door is opened. Our innovative approach earned us recognition from prestigious institutions such as VIT Vellore, VIT Chennai, and SSN Chennai.                 
                   </p>
                </div>
              </div>
            </li>
            <li className="timeline-inverted">
              <div className="timeline-image">
                <img loading="lazy" decoding="async" style={{marginTop:'25px',width:'100px',height:'100px'}} className="rounded-circle img-fluid" src="https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-artificial-intelligence-robotics-flaticons-flat-flat-icons.png" alt=""/>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4>2021</h4>
                  <h4 className="subheading">Harnessing Advanced Technologies(AI & ML)</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">In 2021, we continued our innovation journey by leveraging AI (Artificial Intelligence) and ML (Machine Learning) technologies. Our IoT-based Farm Guard device is specifically designed for farmers, providing advanced protection for farmland against animal intrusion.</p>
                </div>
              </div>
            </li>
            <li>
              <div className="timeline-image">
                <img loading="lazy" decoding="async" style={{marginTop:'25px',width:'125px',}} className="rounded-circle img-fluid" src="https://img.icons8.com/bubbles/100/bullish.png" alt=""/>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4>2022</h4>
                  <h4 className="subheading">Scaling New Heights</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">In 2022, BGENT witnessed significant growth in the installation of our Smart Door Lock Detector and Monitor. 
                  Due to its proven effectiveness and reliability, we expanded our reach and installed door locks in a larger number in college hostels. 
                  This expansion not only highlights the trust placed in our innovative solutions but also underscores our commitment to enhancing security and convenience for our clients.</p>
                </div>
                <div className="timeline-heading">
                  <h4 className="subheading">Continued Innovation</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">Furthermore, our R&D efforts continued to drive innovation in the agricultural sector. 
                  Development on the Farm Guard model progressed steadily, with a focus on enhancing its capabilities and effectiveness. 
                  The Farm Guard remains a key focus area for us as we strive to provide farmers with cutting-edge technology to protect their farmlands from animal intrusion. 
                  Our dedication to leveraging advanced technologies such as AI and ML ensures that the Farm Guard will set a new standard in farm security and efficiency.</p>
                </div>
              </div>
            </li>
            <li className="timeline-inverted">
              <div className="timeline-image">
                <img loading="lazy" decoding="async" style={{marginTop:'25px',width:'125px',height:'125px'}} className="rounded-circle img-fluid" src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/000000/external-motion-sensor-augmented-reality-flaticons-lineal-color-flat-icons.png" alt=""/>
              </div>
              <div className="timeline-panel">
                <div className="timeline-heading">
                  <h4>2023</h4>
                  <h4 className="subheading">Innovative Energy Conservation</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">In 2023, BGENT introduced a groundbreaking device aimed at conserving electricity in educational institutions and hostel facilities. 
                  The new Smart Motion Sensor is designed to intelligently manage lighting and electrical appliances in classrooms, corridors, and hostel bathrooms. 
                  By detecting motion and occupancy, the sensor ensures that lights and appliances are only activated when needed, thus reducing unnecessary energy consumption and contributing to sustainability efforts.</p>
                </div>
                <div className="timeline-heading">
                  <h4 className="subheading">Expanding Reach and Impact</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">Our commitment to excellence led to an expansion of our client base, with Crescent Chennai College joining the ranks of institutions benefiting from our cutting-edge solutions. 
                  This expansion is a testament to the trust and confidence placed in our products.</p>
                </div>
                <div className="timeline-heading">
                  <h4 className="subheading">Revolutionizing Farm Land Protection</h4>
                </div>
                <div className="timeline-body">
                  <p className="text-muted">In a significant development, our Farm Guard model completed its development phase and underwent rigorous testing. The results were outstanding, proving that animals are automatically diverted from farmlands, effectively protecting crops. 
                  Our innovative approach to farm security has garnered attention from government officials, leading to meetings with state and central ministers. 
                  These discussions are focused on deploying the Farm Guard in the forest RFA area to prevent animals entering into people living areas.</p>
                </div>
              </div>
            </li>
            <li className="timeline-inverted">
              <div className="timeline-image">
                <h4>Be Part
                  <br/>Of Our
                  <br/>Story!</h4>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>


  <section className="theme-counter bg-light page-section" id="services" onMouseEnter={()=>setSelected('services')}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12 text-center">
          <h2 className="section-heading text-uppercase">Services</h2>
          <h3 className="section-subheading text-muted"></h3>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <div className="team-member">
            <img loading="lazy" decoding="async" className="mx-auto rounded-circle" src={farmland} alt=""/>
            <h4>Forest & Agriculture Management</h4>
            <p className="text-muted"><i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Farm Guard<br/>
            <i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Protect Farm land from animals intrusion<br/>
            <i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Get the Food Chain System back</p>
            
          </div>
        </div>
        
        <div className="col-sm-4">
          <div className="team-member">
            <img loading="lazy" decoding="async" className="mx-auto rounded-circle" style={{color:"#fed136"}} src={energy} alt=""/>
            <h4>Energy Management</h4>
            <p className="text-muted"><i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Smart Door Lock Detector and Monitor<br/>
            <i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Smart Motion Detector and Monitoring<br/>
            <i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Smart Time Controller</p>
            
          </div>
        </div>
        <div className="col-sm-4">
          <div className="team-member">
            <img loading="lazy" decoding="async" className="mx-auto rounded-circle" src={water} alt="" />
            <h4>Water Management</h4>
            <p className="text-muted"><i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Smart Water Flow Monitor & Controller<br/>
            <i className="fa fa-check-circle" aria-hidden="true" style={{color:"#fed136"}}></i><span> {''}</span>Fully Automatic water Level Controller with Dry-run protection</p>
           
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 mx-auto text-center">
          <p className="large text-muted"></p>
        </div>
      </div>
    </div>
  </section>
  
  <section className="page-section" id="contact"  onMouseEnter={()=>setSelected('contact')}>
    <div className="container">
      <div className="row">
        <div className="col-lg-12 text-center">
          <h2 className="section-heading text-uppercase">Contact Us</h2>
          <h3 className="section-subheading text-muted">Let&apos;s get in touch</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <form id="contactForm" name="sentMessage">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input className="form-control" id="name" type="text" placeholder="Your Name *" required data-validation-required-message="Please enter your name."/>
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <input className="form-control" id="email" type="email" placeholder="Your Email *" required data-validation-required-message="Please enter your email address."/>
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <input className="form-control" id="phone" type="tel" placeholder="Your Phone *" required data-validation-required-message="Please enter your phone number."/>
                  <p className="help-block text-danger"></p>
                </div>
                <div className="form-group">
                  <textarea className="form-control" id="message" placeholder="Your Message *" required data-validation-required-message="Please enter a message."></textarea>
                  <p className="help-block text-danger"></p>
                </div>
              <div className="clearfix"></div>
              <div className="col-lg-12 text-center">
                <div id="success"></div>
                <button id="sendMessageButton" className="btn btn-primary btn-xl text-uppercase" type="submit">Send Message</button>
              </div>
              </div>
              <div className='col-md-6'>
          <div className="form-group">
          <h4 className="section-heading ">Reach Us:</h4>
          <p className="section-heading">Mr.P.G.Ragavandir(CEO),<br/>
          E-mail : ceo@bgenterprises.org.in,<br/>#369, Phase III, Sathuvachari, Vellore, Tamil Nadu 632009.</p><br/>
          <p style={{ alignItems: 'center', display: 'flex' }}>
          <iframe title="BG Enterprises office location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.4522748762756!2d79.16461057484085!3d12.942885687369841!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad387057eef1d3%3A0xe54accd01f7775ee!2sBGENT!5e0!3m2!1sen!2sin!4v1713430715901!5m2!1sen!2sin" width="700" height="400" style={{border:0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                 </p>
          </div>
        </div>
            </div>
            
          </form>
        </div>
      </div>
        
    </div>
  </section>

  
  <footer className="footer">
    <div className="container">
      <div className='row align-items-center'>
        <p>
          
        </p>

      </div>
      <div className="row align-items-center">
        
        <div className="col-md-4">
          <ul className="list-inline social-buttons">
            <li className="list-inline-item">
              <a href="#something" className="landing-social landing-social-twitter" aria-label="Twitter" title="Twitter">
                <TwitterIcon aria-hidden="true" />
              </a>
            </li>
            <li className="list-inline-item">
              <a href="#something" className="landing-social landing-social-facebook" aria-label="Facebook" title="Facebook">
                <FacebookIcon aria-hidden="true" />
              </a>
            </li>
            <li className="list-inline-item">
              <a href="#something" className="landing-social landing-social-youtube" aria-label="YouTube" title="YouTube">
                <YouTubeIcon aria-hidden="true" />
              </a>
            </li>
            <li className="list-inline-item">
              <a href="#something">
              <img loading="lazy" decoding="async" src={whatsappnumber} style={{width:'75px',height:'75px'}} title="WhatsApp" alt="WhatsApp contact code"></img>
              </a>
            </li>
            
          </ul>
        </div>
        <div className="col-md-4">
          <span className="copyright">Copyright &copy; 2026 BGENT. All Rights Reserved.</span>
        </div>
      </div>
    </div>
  </footer>
    </div>
  );
}
export default LandingPage;
